export default __webpack_public_path__ + "ef732a8f56ea8f9ad0900545832f97bd.png";